import React, { useState } from "react";
import "./ManualTimeInput.css";
const ManualTimeInput = ({ isVisible, onSave, onClose, heading, settings }) => {
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");

  const handleSave = () => {
    const formattedMinutes =
      minutes.trim() !== "" && !isNaN(parseInt(minutes, 10))
        ? parseInt(minutes, 10).toString()
        : "";

    const minutesPart = formattedMinutes === "0" ? "" : formattedMinutes;
    const formattedTime =
      minutesPart !== ""
        ? `${minutesPart}:${seconds.padStart(2, "0")}`
        : `:${seconds.padStart(2, "0")}`;

    const numMins = parseInt(minutes) || 0;
    const numSecs = parseInt(seconds) || 0;
    const totalSecs = numMins * 60 + numSecs;

    if (settings) {
      onSave(totalSecs);
    } else {
      onSave(formattedTime);
    }

    onClose();
    setMinutes("");
    setSeconds("");
  };

  if (!isVisible) return null;

  return (
    <div className="overlay-manual-time">
      <div className="modal-manual-time">
        <h2 className="heading-manual-time">{heading || "TIME ON GAME CLOCK"}</h2>

        <div className="row-manual-time">
          <input
            className="input-manual-time"
            type="text"
            placeholder="00"
            value={minutes}
            onChange={(e) => setMinutes(e.target.value)}
            maxLength={2}
          />
          <span className="colon-manual-time">:</span>
          <input
            className="input-manual-time"
            type="text"
            placeholder="00"
            value={seconds}
            onChange={(e) => setSeconds(e.target.value)}
            maxLength={2}
          />
        </div>
        <p className="smallTxt-manual-time">MM:SS</p>

        <button className="saveBtn-manual-time" onClick={handleSave}>Save</button>
      </div>
      <div className="backdrop-manual-time" onClick={onClose}></div>
    </div>
  );
};

export default ManualTimeInput;
